var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_33_491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96047 20.8453L8.50806 19.6488C8.89727 18.7986 8.89773 17.8479 8.50899 16.9974L7.76796 15.3757C7.17411 14.0757 5.7285 13.2413 4.14599 13.2851L3.97125 13.2901C2.50601 13.3307 1.16505 12.5641 0.603907 11.3647L0.0988195 10.2856C-0.0329398 10.0038 -0.0329398 9.68672 0.0988195 9.40486C0.230579 9.123 0.483349 8.89866 0.801534 8.78194C1.11972 8.66523 1.4781 8.66481 1.79628 8.78153C2.11494 8.89825 2.3677 9.12217 2.49946 9.40403L2.77466 9.99217C2.9994 10.4723 3.53064 10.7835 4.11748 10.7794L4.15906 10.779C4.49781 10.7765 4.81319 10.6254 5.00101 10.3763C5.18931 10.1267 5.22576 9.81089 5.09867 9.53275L5.05615 9.43963C4.85478 8.99924 4.91411 8.49925 5.21407 8.10564C5.51357 7.71161 6.0149 7.47569 6.55129 7.4761L6.75828 7.47652C7.14889 7.47652 7.49885 7.69009 7.63855 8.01334L9.09071 11.3729C9.34862 11.9698 9.99292 12.3655 10.7143 12.3704C11.4357 12.375 12.0866 11.988 12.3548 11.3945L12.7412 10.5389C13.3397 9.21446 12.9169 7.69919 11.6904 6.77414L11.5764 6.68846C10.4602 5.8466 10.0485 4.48074 10.5424 3.2581L10.9867 2.15837C11.1026 1.87113 11.3428 1.63645 11.6544 1.50608C11.9656 1.3757 12.323 1.35997 12.6473 1.46303C12.9715 1.56609 13.2374 1.77882 13.3846 2.05448C13.5317 2.33055 13.5495 2.64676 13.4336 2.93401L13.214 3.47788C13.0024 4.00104 13.1706 4.58546 13.6387 4.95507L13.9027 5.16326C14.1162 5.33213 14.4092 5.39794 14.6877 5.33999C14.9661 5.28163 15.1956 5.10696 15.3016 4.87187L17.1462 0.78921C17.2859 0.479616 17.5597 0.231682 17.9064 0.100891C18.2526 -0.030314 18.6442 -0.0336162 18.9937 0.0913803C19.7155 0.349237 20.066 1.07768 19.7744 1.71715L15.5207 11.0629C15.4507 11.2169 15.5058 11.3936 15.6553 11.4938C15.8048 11.594 16.0113 11.5931 16.1599 11.4913L16.1716 11.483L18.6708 9.64119C19.3964 9.10644 19.6833 8.2356 19.396 7.43927L19.3567 7.33124C19.2516 7.04027 19.2815 6.72488 19.4394 6.45336C19.5973 6.18226 19.8702 5.97738 20.1982 5.88467C20.5262 5.79196 20.8836 5.81763 21.1897 5.95752C21.4962 6.09742 21.727 6.33913 21.8321 6.6301L22.2325 7.73893C22.6792 8.97771 22.2134 10.332 21.0626 11.1387L19.032 12.5629C18.7068 12.7905 18.5624 13.1655 18.6624 13.5215C18.7624 13.8778 19.0885 14.1493 19.4955 14.2156C19.9272 14.2859 20.2954 14.5372 20.4813 14.8894C20.6673 15.2412 20.6495 15.6514 20.4337 15.9899L20.0758 16.5516C19.8744 16.8678 19.466 17.0325 19.0647 16.9597L16.5982 16.5119C14.7194 16.1708 12.8328 17.0632 12.1076 18.6364L10.7816 21.513C12.0258 21.5444 13.2355 21.2477 14.2877 20.693C14.4027 20.6318 14.5414 20.6173 14.6694 20.6537C15.2918 20.8313 15.7277 21.3284 15.766 21.9062C15.8039 22.4844 15.4366 23.0237 14.8419 23.2637C12.9257 24.0261 10.7316 24.2306 8.57954 23.7157C6.13218 23.13 4.16608 21.7162 2.95595 19.8868C2.62281 19.3847 2.6742 18.7523 3.08536 18.2978C3.49653 17.8429 4.18196 17.6604 4.80758 17.8392C4.93467 17.8752 5.00896 17.8963 5.00896 17.8963C5.58132 19.1446 6.60643 20.2001 7.96047 20.8453Z",
    fill: "#E65A53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_33_491",
    x: 0,
    y: -1,
    width: 23.4,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.639 0 0 0 0 0.62 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_33_491"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.0500002 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_33_491",
    result: "effect2_innerShadow_33_491"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.150e1065032975d3322c9b4bcf8c50e2.svg";
export { ForwardRef as ReactComponent };